<script setup lang="ts">
import { computed } from 'vue'
import { Vue3Lottie } from 'vue3-lottie'
import { userModule } from '@/store/user/module'
import MotivationalMomentLM from '@/assets/levelup/animation-json/MotivationalMomentLM.json'
import MotivationalMomentDM from '@/assets/levelup/animation-json/MotivationalMomentDM.json'
import BottomRightBlob from '@/components/LevelUpQuizIntro/BottomRightBlob.vue'
import TopLeftBlob from '@/components/LevelUpQuizIntro/TopLeftBlob.vue'

const emit = defineEmits<{
    'animationEnd': []
}>()

const isDarkMode = computed(() => {
    return userModule.state.settings.isDarkMode
})

</script>

<template>
    <div
        v-dark
        class="motivational-moment"
    >
        <BottomRightBlob class="motivational-moment__bottom-right-blob" />
        <TopLeftBlob class="motivational-moment__top-left-blob" />
        <div class="motivational-moment__content-container">
            <div
                v-dark
                class="motivational-moment__text"
            >
                5 in a row. Nice!
            </div>
            <Vue3Lottie
                ref="animationContainer"
                class="motivational-moment__animation"
                :animationData="isDarkMode ? MotivationalMomentDM : MotivationalMomentLM" 
                :height="'100%'" 
                :width="'100%'"
                :loop="false"
                :speed="0.5"
                @onComplete="emit('animationEnd')"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.motivational-moment {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: $gray-background;
    z-index: 3;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &--dark {
        background-color: $mariner;
    }

    &__text {
        text-align: center;
        font-weight: 600;
        letter-spacing: 0.3px;
        color: $slate;
        font-size: 20px;
        line-height: 27px;
        margin-bottom: 20px;
        opacity: 0;
        animation: fade-in 0.5s ease-in forwards;

        &--dark {
            color: $cloudy;
        }
    }

    &__animation {
        height: 155px;
        width: 194px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }

    &__bottom-right-blob {
        position: absolute;
        bottom: 0;
        right: 0;

        @include breakpoint(black-bear) {
            transform: rotateY(180deg);
            left: 0;
        }
    }

    &__top-left-blob {
        position: absolute;
        top: 0;
        left: 0;

        @include breakpoint(black-bear) {
            transform: rotateY(180deg);
            left: auto;
            right: 0;
        }
    }

    @keyframes fade-in {
        to {
            opacity: 1;
        }
    }
}
</style>